import React, { FunctionComponent } from "react";
import { GameCodes, RoundHistoryComponentProps, RoundType } from "../../type";
import Utils from "../../utils";
import CoinDozerUtils from "./utils";
import { CoinDozerGameData, TriggeredCoin } from "./types";
import "./coin-dozer.scss";
import { GeneralRoundHistoryView } from "../../components";
import BigNumber from "bignumber.js";
import { useTranslator } from "../../context/TranslationContext";

export const CoinDozerRoundHistoryView: FunctionComponent<
  RoundHistoryComponentProps
> = ({ roundHistory, type, id }) => {
  const spinData = roundHistory.spins[0];
  const gd = spinData.gameData as CoinDozerGameData;
  const profit =
    roundHistory.roundType !== RoundType.FreePlay
      ? BigNumber(roundHistory.winAmount).minus(roundHistory.betAmount)
      : BigNumber(roundHistory.winAmount);

  const translator = useTranslator();
  return (
    <GeneralRoundHistoryView
      gameCode={GameCodes.CoinDozer}
      roundHistory={roundHistory}
    >
      <div className="card mb-3">
        <div className="card-body">
          <div className="card-title fs-4 fw-bold">
            {translator.get("spin")}
          </div>

          <hr />
          <table className="table table-bordered table-striped ">
            <colgroup>
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th>{translator.get("symbol")}</th>
                <th>{translator.get("bet")}</th>
                <th>{translator.get("multiplier")}</th>
                <th>{translator.get("win")}</th>
                <th>{translator.get("profit")}</th>
              </tr>
            </thead>
            <tbody>
              {gd.triggeredCoins.map((s) => (
                <CoinRecord
                  key={(Math.random() * 100).toString(16)}
                  betAmountOfCoin={
                    roundHistory.betAmount / gd.triggeredCoins.length
                  }
                  triggeredCoin={s}
                  roundType={roundHistory.roundType}
                />
              ))}
              <tr>
                <td className="text-end">
                  <strong>{translator.get("win")}:</strong>
                </td>
                <td>
                  <strong>{Utils.asCurrency(roundHistory.betAmount)}</strong>
                </td>
                <td></td>
                <td>
                  <strong>{Utils.asCurrency(roundHistory.winAmount)}</strong>
                </td>
                <td className={profit.gte(0) ? "text-success" : "text-danger"}>
                  <strong>{Utils.asCurrency(profit)}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </GeneralRoundHistoryView>
  );
};

type Props = {
  betAmountOfCoin: number;
  triggeredCoin: TriggeredCoin;
  roundType: RoundType
};
const CoinRecord: FunctionComponent<Props> = ({
  betAmountOfCoin,
  triggeredCoin,
  roundType
}) => {
  const winAmount = betAmountOfCoin * triggeredCoin.multiplier;
  const profit = roundType !== RoundType.FreePlay
  ? BigNumber(winAmount).minus(betAmountOfCoin)
  : BigNumber(winAmount);
  return (
    <tr>
      <td>
        {winAmount
          ? CoinDozerUtils.convertSymbol(triggeredCoin.coin.symbolId, ["big"])
          : "-"}
      </td>
      <td>{Utils.asCurrency(betAmountOfCoin)}</td>
      <td>{triggeredCoin.multiplier}</td>
      <td>{Utils.asCurrency(betAmountOfCoin * triggeredCoin.multiplier)}</td>
      <td className={profit.gte(0) ? "text-success" : "text-danger"}>
        {Utils.asCurrency(profit)}
      </td>
    </tr>
  );
};
